/**
 * Created by Darius on 2017.04.02.
 */
import fetch from 'isomorphic-fetch';

const options = {
    credentials: 'same-origin',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
};

const RoleServices = {
    getRoles: () => fetch(`/api/roles/`, options),
    getRole: (id) => fetch(`/api/roles/${id}`, options),
    postRole: (role) =>
        fetch(`/api/roles/`, Object.assign({}, options, {
            method: 'POST',
            body: JSON.stringify(role)
        })),
    deleteRole: (id) =>
        fetch(`/api/roles/${id}`, Object.assign({}, options, {
            method: 'DELETE'
        }))
};

export default {
    RoleServices
};